var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlignFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 5.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 13,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(3.914214, 4.085786) rotate(-45.000000) translate(-3.914214, -4.085786) ",
  x: 0.414213562,
  y: 2.58578644,
  width: 7,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(3.914214, 6.914214) rotate(-45.000000) translate(-3.914214, -6.914214) ",
  x: 2.41421356,
  y: 3.41421356,
  width: 3,
  height: 7,
  rx: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.4188514,6.29753109 L19.9502426,9.82892229 L19.9530518,9.83173147 C20.3431686,10.2218483 20.3497919,10.8477293 19.9502426,11.2472786 L16.4188514,14.7786698 C16.0271832,15.170338 15.3966652,15.1748398 15.0033043,14.7814789 L14.2947219,14.0728965 C13.9046051,13.6827797 13.8979818,13.0568987 14.2975311,12.6573494 L16.416,10.538 L14.2975311,8.41885143 C13.9058628,8.02718316 13.9013611,7.39666518 14.2947219,7.00330434 L15.0033043,6.29472191 C15.3934211,5.90460511 16.0193022,5.89798183 16.4188514,6.29753109 Z",
  fill: "currentColor"
}))));
export default SvgAlignFull;